<template>
  <v-layout
    style="margin-top:5%"
    row
    justify-center
    align-center
  >
    <v-card
      class="login"
      flat
      style=" border-radius:6px; border: 1px solid #eeeeee;"
    >
      <branding-header-card />

      <v-card-text>
        <v-layout row>
          <v-flex>
            <v-layout
              v-show="!loading"
              column
            >
              <v-layout row>
                <v-flex>
                  <v-form>
                    <v-layout>
                      <span
                        class="ml-2"
                        style="opacity:0.6; font-size:10; font-weight:700"
                      >Sign In to continue to OneChart</span>
                    </v-layout>

                    <v-text-field
                      class="mt-3"
                      outline
                      hide-details
                      label="Email"
                      v-model="email"
                      required
                    ></v-text-field>

                    <v-text-field
                      outline
                      hide-details
                      class="mt-4"
                      label="Password"
                      required
                      hint="At least 8 characters"
                      :append-icon="isPassVisible ? 'visibility_off' : 'visibility'"
                      :append-icon-cb="() => (isPassVisible = !isPassVisible)"
                      v-model="password"
                      :type="isPassVisible ? 'text' : 'password'"
                      @keydown.native="enterPressed"
                    ></v-text-field>
                  </v-form>
                </v-flex>
              </v-layout>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>

      <v-card-actions
        style="background-color:white"
        flat
      >
        <v-spacer></v-spacer>
        <v-btn
          style="min-width:0"
          depressed
          color="primary"
          @click="submit()"
        >
          <span v-show="!loadingLogin">{{signInButtonText}}</span>
          <v-progress-circular
            indeterminate
            color="white"
            :size="20"
            v-show="loadingLogin"
          />
        </v-btn>
      </v-card-actions>
    </v-card>

  </v-layout>
</template>

<style lang="scss" scoped>
@import '../../../styles/form';

$primaryColor: #1565c0;
$dark-charcoal: #222;

.login {
  max-width: 520px;
  width: 100%;

  .hints {
    font-size: 12px;
    color: red;
  }
}

.logo {
  display: flex;
  align-items: center;
  font-size: 28px;
  color: $primaryColor;
  padding: 10px 24px;
  border-radius: 8px;
  text-transform: uppercase;
  cursor: pointer;
  letter-spacing: 7px;
  font-weight: 300;
  .logo-icon {
    margin-right: 5px;
    font-size: 40px;
  }
}
</style>

<script>
import { mapState, mapActions } from 'vuex'
import bus from '@/core/helpers/bus'
import BrandingHeaderCard from '@/components/cards/BrandingHeaderCard'

export default {
  components: {
    BrandingHeaderCard
  },
  data() {
    return {
      loadingLogin: false,
      loading: false,
      email: '',
      password: '',
      isPassVisible: false
    }
  },
  computed: {
    ...mapState('auth', ['user', 'authUser', 'redirect']),
    signInButtonText() {
      return 'Sign In'
    }
  },
  methods: {
    ...mapActions('auth', ['signIn']),
    enterPressed(e) {
      // Enter is pressed
      if (e.keyCode === 13) {
        this.submit()
      }
    },
    submit() {
      this.loadingLogin = true
      const credentials = {
        email: this.email,
        password: this.password
      }
      this.login(credentials)
    },
    login(credentials) {
      const vm = this

      vm.signIn(credentials).then(
        () => {
          vm.$ga.event('login', 'sign-in', credentials.email)
          vm.$router.push({ name: 'HomePage' })
        },
        () => {
          vm.$ga.event('login', 'failed-sign-in', credentials.email)

          bus.$emit('stopLoading')
          this.loadingLogin = false
          vm.toast('error', 'Credentials invalid')
        }
      )
    },
    toast(type, text) {
      bus.$emit('toast', { type, text })
    }
  },
  created() {
    if (this.user) {
      return location.reload()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/auth/LoginPage.vue